import React from 'react';
import { CurrencyInput, Field } from 'ui';
import ErrorMessage from '~/components/Form/ErrorMessage';
import ListFlowExpandablePanel from '~/components/ListFlow/Elements/ListFlowExpandablePanel';
import RequiredStar from '~/components/ListFlow/RequiredStar';
import {
  changedAutoPriceDrop,
  getListFlowAutoPriceDrop,
} from '~/store/listFlow/slices/pricing';
import { getListFlowAutoPriceDropError } from '~/store/listFlow/ui';
import { useAppDispatch, useAppSelector } from '~/store/store';

interface Props {}

const ListFlowAutoPriceDrop: React.FC<Props> = () => {
  const dispatch = useAppDispatch();
  const autoPriceDrop = useAppSelector(getListFlowAutoPriceDrop);
  const error = useAppSelector(getListFlowAutoPriceDropError);

  return (
    <ListFlowExpandablePanel
      expanded={autoPriceDrop.enabled}
      setExpanded={expanded =>
        dispatch(changedAutoPriceDrop({ enabled: expanded }))
      }
      title="Auto Price Drop"
    >
      <div className="mb-4 text-sm">
        Automatically drop the price of your items by 10% every 14 days until it
        reaches your price floor.
      </div>

      <Field
        label={
          <span>
            Price Floor <RequiredStar />
          </span>
        }
        hint={
          <span className="text-turf-green-500 text-sm">
            We will not drop the price of your item below this.
          </span>
        }
      >
        <CurrencyInput
          onChange={value =>
            dispatch(changedAutoPriceDrop({ newMinimum: value }))
          }
          value={autoPriceDrop.minimum}
        />
      </Field>

      <ErrorMessage errors={error} />
    </ListFlowExpandablePanel>
  );
};

export default ListFlowAutoPriceDrop;
